export default __webpack_public_path__ + "static/media/plus-trainer.4238a0b6.svg";